import { apiChatTS as http } from '../../../http';

class AutomaticCloseChatConfigService {
  constructor() {}

  async create(configData) {
    return http.post(`queue/automatic-close-chat/create`, configData);
  }

  async update(path, configData) {
    return http.put(`queue/automatic-close-chat/update/${path}`, configData);
  }

  delete(id) {
    return http.delete(`queue/automatic-close-chat/delete/${id}`);
  }

  find() {
    return http.get(`queue/automatic-close-chat/find-all`);
  }

  findById(id) {
    return http.get(`queue/automatic-close-chat/find/${id}`);
  }
}

export default new AutomaticCloseChatConfigService();
